import { render, staticRenderFns } from "./PlateNumber.vue?vue&type=template&id=43d39cb0&"
import script from "./PlateNumber.vue?vue&type=script&lang=js&"
export * from "./PlateNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports